import { CustomGetJobPhaseQuery, JobPhase, useCustomGetJobPhaseQuery } from "generated/graphql";

type GeneratedJobPhase = NonNullable<CustomGetJobPhaseQuery["getJobPhase"]>;

export type CustomJobPhase = Omit<
  GeneratedJobPhase,
  | "costingMode"
  | "actualSubcontractorCost"
  | "actualSubcontractorName"
  | "actualSubcontractorReference"
> & {
  costingMode?: "STANDARD" | "SUBCONTRACTED" | null;
  actualSubcontractorCost?: string | number | null;
  actualSubcontractorName?: string | null;
  actualSubcontractorReference?: string | null;
};

export default function useGetJobPhase({ id }: { id?: JobPhase["id"] | null }) {
  const { loading, data, error, refetch } = useCustomGetJobPhaseQuery({
    variables: { id: id ?? "" },
    skip: !id,
  });

  return {
    loading,
    data: (data?.getJobPhase as CustomJobPhase | null) ?? null,
    error,
    refetch,
  };
}
